import { toNode } from 'utils/html_creator';
import view from './layout.html';

const dialog = (data={}) => {
  let $view = toNode(view);
  Handler($view, data);
  document.querySelector('body').appendChild($view);
}

const Handler = (layout, data) => {

  let title = layout.querySelector('#cmp_dialog_title'),
    body = layout.querySelector('#cmp_dialog_info'),
    btn_cancel = layout.querySelector('#cmp_cancel'),
    btn_ok = layout.querySelector('#cmp_ok'),
    card = layout.firstElementChild;

  card.classList.add(`ml-modal-card-${data.size ? data.size : 'sm'}`);

  if(data.cssClass) layout.classList.add(data.cssClass);

  if(data.title){
    let html = `<p class="ml_paragraph ml_text-center ml_strong">${data.title}</p>`
    title.innerHTML = html;
  }else{
    if(data.title_html) title.innerHTML = data.title_html;
  }

  if(data.body){
    let html = `<p class="ml_paragraph ml_text-center">${data.body}</p>`
    body.innerHTML = html;
  }else{
    if(data.body_html) body.innerHTML = data.body_html;
  }
  if(data.btn_cancel) btn_cancel.innerText = data.btn_cancel;
  if(data.btn_ok) btn_ok.innerText = data.btn_ok;
  
  layout.addEventListener('click', ({ target }) => {
    if(target.matches('#cmp_dialog_close')){
      layout.remove();
    }
    
    if(target === btn_ok){
      if(data.ok) data.ok();
      layout.remove();
    }

    if(target === btn_cancel){
      if(data.cancel) data.cancel();
      layout.remove();
    }
  });
}

export default dialog;

